import { Grid } from "@mui/material";
import React from "react";
import styles from "./introducing.module.scss";

export const VOfficeIntroducing = () => {
  return (
    <section className={styles.section_introducing}>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h2 className={styles.sec_title}>
            Welcome to UniSearch’s Virtual Office
          </h2>
          <p className={`${styles.sec_desc} ${styles.margin_bottom}`}>
            We bring you the same support you would get from us in person from
            the comfort of your own home!
          </p>
          <p className={`${styles.sec_desc} ${styles.margin_bottom}`}>
            The world might feel like it’s come to a standstill, or at best, is
            moving in fits and starts. But your study abroad dreams don’t need
            to stop along with it. Keeping your dreams on track is our top
            priority, tied with our commitment to ensuring your safety. Through
            UniSearch’s virtual office, you can safely connect with our team of
            expert counsellors from wherever you are. Get complete, 360-degree
            support at your fingertips with UniSearch.
          </p>
        </div>

        <div className={styles.steps_card_wrapper}>
          <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <div className={styles.step_card}>
                <h2 className={`${styles.step_number} ${styles.num_one}`}>
                  Step 1
                </h2>
                <p className={styles.step_desc}>
                  Fill out the enquiry form on the UniSearch website
                </p>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.step_card} ${styles.card_even}`}>
                <h3 className={`${styles.step_number} ${styles.num_two}`}>
                  Step 2
                </h3>

                <p className={styles.step_desc}>
                  Receive a Zoom link confirming your booking and appointment by
                  email
                </p>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={styles.step_card}>
                <h3 className={`${styles.step_number} ${styles.num_three}`}>
                  Step 3
                </h3>

                <p className={styles.step_desc}>
                  Download the Zoom app on your phone or laptop
                </p>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className={`${styles.step_card} ${styles.card_even}`}>
                <h3 className={`${styles.step_number} ${styles.num_four}`}>
                  Step 4
                </h3>

                <p className={styles.step_desc}>
                  Join the Zoom link at the appointed date and time and connect
                  one-to-one with a counsellor
                </p>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={styles.title_wrapper}>
          <p className={`${styles.sec_desc} ${styles.text_highlight}`}>
            Get in touch with our study abroad specialists, wherever you are!
          </p>
          <p className={`${styles.sec_desc} ${styles.margin_bottom}`}>
            UniSearch’s passionate team of study abroad specialists brings years
            of experience into the equation to personalise your higher education
            journey to your needs. With their impressive track record in
            assisting students through successful admissions, you can rest
            assured that you will be in the right hands!
          </p>
        </div>
      </div>
    </section>
  );
};

export default VOfficeIntroducing;
